const SocialIcons = () => {
  return (
    <div className="socialIcons">
      <a className="icon" aria-label="Visit my Github account" href="https://github.com/adeeb-samad">
        <i className="fa-brands fa-github" aria-label="Visit my Github account" title="Adeeb's GitHub Profile"></i>
      </a>
      <a className="icon" aria-label="See my LinkedIn profile" href="https://www.linkedin.com/in/adeeb-samad/">
        <i className="fa-brands fa-linkedin" title="Adeeb's LinkedIn Profile"></i>
      </a>
      <a className="icon" aria-label="Follow me on Facebook" href="https://www.facebook.com/adeebsamed">
        <i className="fa-brands fa-facebook" title="Adeeb's Facebook Profile"></i>
      </a>
    </div>
  );
};

export default SocialIcons;
